/**
 * 语言状态管理（与 member-template-vue 保持一致）
 * localStorage key: current_i18n
 * 值格式: zh_CN / en_US
 */

const STORAGE_KEY = "current_i18n";
const DEFAULT_LANG = "zh_CN";

// 兼容旧值映射
const LEGACY_MAP = {
  zh: "zh_CN",
  zh_cn: "zh_CN",
  "zh-CN": "zh_CN",
  chinese_simplified: "zh_CN",
  en: "en_US",
  en_US: "en_US",
  "en-US": "en_US",
  english: "en_US",
  cn: "zh_CN",
};

class LangManager {
  constructor() {
    this._listeners = [];
    this._available = [];
    let raw = localStorage.getItem(STORAGE_KEY) || DEFAULT_LANG;
    // 兼容旧值
    if (LEGACY_MAP[raw]) {
      raw = LEGACY_MAP[raw];
    }
    this._current = raw;
  }

  get current() {
    return this._current;
  }

  set current(lang) {
    this._current = lang;
    localStorage.setItem(STORAGE_KEY, lang);
  }

  get available() {
    return this._available;
  }

  setAvailable(langs) {
    this._available = langs || [];
    this._emitChange();
  }

  /**
   * 切换语言并刷新页面
   */
  switch(lang) {
    this.current = lang;
    window.location.reload();
  }

  /**
   * 切换语言但不刷新（静默）
   */
  switchSilent(lang) {
    this.current = lang;
    this._emitChange();
  }

  /**
   * 监听语言变化
   */
  onChange(fn) {
    this._listeners.push(fn);
    return () => {
      this._listeners = this._listeners.filter((l) => l !== fn);
    };
  }

  _emitChange() {
    this._listeners.forEach((fn) => fn(this._current, this._available));
  }

  /**
   * 从 i18n 配置初始化可用语言
   */
  initFromConfig(i18nConfig) {
    if (i18nConfig && i18nConfig.enabled && i18nConfig.items) {
      const langs = i18nConfig.items.filter((item) => item.isEnable == "1");
      this.setAvailable(langs);
    }
  }

  /**
   * 判断当前是否非简体中文（即需要显示翻译内容）
   */
  isNonCn() {
    return this._current !== "zh_CN";
  }

  /**
   * 获取当前语言对应的 i18n 字段后缀，如 en-US -> en_us
   */
  getFieldSuffix() {
    return this._current.toLowerCase().replace("-", "_");
  }
}

const langManager = new LangManager();

export default langManager;
export { STORAGE_KEY, DEFAULT_LANG };
